
export default async function GetReviewsAction(token) {
	return fetch('https://api.saastic.com/public/reviews?limit=1000&score=3', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`,
		},
	})
	.then(data => data.json())
	.catch(error => error)
}



